<div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%" (click)="common.outSide($event)">
    <div class="header col-sm-12">
        <div class="col-sm-7">
            <h2 style="width:95%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">  Libellés négociés du client {{detail.nomClient}} </h2>
        </div>
        <div class="col-sm-5 text-right">
            <button class="btn-header uppercase" id="maj" (click)="majRetroLibelleNego()"> MAJ retro. des libellés </button>
            <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
        </div>
    </div>
    <div class="col-sm-12 ligneBon liste">

        <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listLibelleNegocie || []"
            [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
            [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator" [selected]="selected">

            <ngx-datatable-column prop="article.code">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Article </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="article.libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Libellé </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span> {{value}} </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Libellé Négocié</span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span> {{value}} </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="articleContenu.libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Contenu </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.articleContenu ? value || row.articleContenu.libelleObjetEntite : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="typeContenant.libelleObjetEntite">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Contenant </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value || 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="chantier.numChantier">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Chantier </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.chantier ? (value || row.chantier.responsable) : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="agence.libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Agence </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ row.agence ? (value || row.agence.libelleObjetEntite) : 'Toutes'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="exutoire.nom">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Exutoire </span>
                        <div class=" shorticone pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.exutoire ? (value || row.exutoire.libelleObjetEntite) : 'Tous'}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                [resizeable]="false">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                        <button class="btn-detail" (click)="showFormEdit(row);">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <button class="btn-detail" (click)="selectedRow = row; common.openModal(modalService, confirme)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
    <div class="addLigne col-sm-12 uppercase">
        <div class="col-sm-7 text-left">
            <button class="btn-add" id="addLigne" (click)="showFormEdit({})">
                <i class="fa fa-plus"></i>
            </button>
            <span (click)="showFormEdit({})">Ajouter une ligne</span>
        </div>
        <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isEdit" #formEdit (click)="common.outSide($event)">
    <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
        <h4 class="modal-title pull-left col-sm-8"> {{!selectedRow.add ? ('Libellé négocié de l\'article : ' +
            selectedRow.article.libelle ): 'Ajout d\'un libéllé négocié'}} </h4>
        <div class="col-sm-4 text-right">
            <button type="button" class="btn-header uppercase" (click)="selectedRow = {};isEdit = false;"> Fermer
            </button>
            <button type="button" class="btn-header uppercase actionPricipal" (click)="selectedRow.article ? validerFormEdit() : false;">
                Valider </button>
        </div>
    </div>
    <div class="modalFicheClient col-sm-12">
        <div class="col-sm-12">
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Article :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                        (selectfunction)="selectedRow.article = $event; setValue($event)" [notOblig]="true" [label]="''" [selectvalue]="true"
                        [results]="dataArticle" [id]="'modedepaie article'" [defaultsearch]="selectedRow.article ? (selectedRow.article.libelle || selectedRow.article.libelleObjetEntite) : ''"
                        [autohide]="true" [dropdownclass]="'dropDownPrixNego'" (keyenterfunction)="common.focusNext('.modalFicheClient')"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Libellé Négo. :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <input type="text" class="form-control" [(ngModel)]="selectedRow.libelle" autocomplete="off"
                        (keydown.enter)="common.focusNext('.modalFicheClient')">
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Chantier :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
                    <app-autocomplete [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)"
                        [selectvalue]="true" (selectfunction)="selectedRow.chantier = $event;" [results]="listChantier"
                        [showonclick]="true" [label]="''" id="modedepaie autoCht" [defaultsearch]="selectedRow.chantier ? selectedRow.chantier.numChantier : ''"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Agence :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.chantier && selectedRow.chantier.id}">
                    <app-autocomplete (selectfunction)="selectedRow.agence = $event;" [results]="listeAgence"
                        [highlight]="true" [id]="'modedepaie agence'" [isCombo]="true" [defaultselected]="selectedRow.agence"
                        [defaultsearch]="selectedRow.agence ? selectedRow.agence.libelleObjetEntite : listeAgence[0].libelleObjetEntite"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Article Contenu :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': !isFamille2 }">
                    <app-autocomplete [placeholder]="selectedRow.articleContenu ? '' : 'Article Contenu'"
                        (searchfunction)="searchArticleContenu($event)" (selectfunction)="selectedRow.articleContenu = $event;"
                        [notOblig]="true" [label]="''" [selectvalue]="true" [results]="artContenu" [id]="'modedepaie artContenu'"
                        [defaultsearch]="selectedRow.articleContenu ? (selectedRow.articleContenu.libelle || selectedRow.articleContenu.libelleObjetEntite) : artContenu[0].libelleObjetEntite.libelleObjetEntite"
                        [autohide]="true" (keyenterfunction)="common.focusNext('.modalFicheClient');" [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Contenant :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': isFamille2 }">
                    <app-autocomplete (selectfunction)="selectedRow.typeContenant = $event;" [isCombo]="true" [results]="typeContenant"
                        [highlight]="true" [label]="''" id="modedepaie typecontenants" [selectvalue]="true"
                        [placeholder]="'Type contenant'" [defaultselected]="selectedRow.typeContenant" [defaultsearch]="selectedRow.typeContenant ? selectedRow.typeContenant.libelleObjetEntite : typeContenant[0].libelleObjetEntite"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                    Exutoire :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                    <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)" [id]="'modedepaie exutoire'"
                        (selectfunction)="selectedRow.exutoire = $event" [results]="listExutoire" [showonclick]="true"
                        [selectvalue]="true" [label]="''" [defaultselected]="selectedRow.exutoire" [defaultsearch]="selectedRow.exutoire ? (selectedRow.exutoire.libelleObjetEntite || selectedRow.exutoire.nom) : listExutoire[0].libelleObjetEntite"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #confirme>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Suppression de libellé </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="selectedRow = {};common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg"> Êtes-vous sûr de vouloir supprimer le libellé sélectionné ? </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="deleteLigne(selectedRow)"> OUI </button>
            <button type="button" class=" btn-close" (click)="selectedRow = {};common.closeModal()"> NON </button>
        </div>
    </div>
</ng-template>

<ng-template #msg>
        <div class="modal-body" style="height: auto">
            <div>
                <div class="col-sm-12">
                    <label class="cofirmemsg" [innerHTML]="error"> </label>
                </div>
            </div>
            <div class="text-right" style="margin-top: 15px;">
                <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
                </button>
            </div>
        </div>
    </ng-template>